/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */

export const AccountsApiEnum = {
    GET_ACCOUNTS: (id: string): string => {
        return '/accounts/' + id;
    },
    DELETE_ACCOUNTS: (id: string): string => {
        return '/accounts/' + id;
    },
    PATCH_ACCOUNTS_UPDATE: (id: string): string => {
        return '/accounts/' + id;
    },
    PATCH_ACCOUNTS_ACTIVATE: (id: string, code: string): string => {
        return `/accounts/${id}/${code}`;
    },
    POST_ACCOUNTS_ADD: '/accounts/',
    GET_ACCOUNTS_ACTIVATE_INVITE: (id: string, token: string): string => {
        return `/accounts/${id}/${token}/invite`;
    },
    POST_ACCOUNTS_RECOVER: '/accounts/recovery',
    DELETE_ACCOUNTS_SSO: (id: string): string => {
        return `/accounts/${id}/auth`;
    },
    GET_ACCOUNTS_MARKETING_ACTIVATE: (hubspotId: string): string => {
        return `/accounts/mkt/${hubspotId}`;
    },
    PATCH_ACCOUNTS_MARKETING_ACTIVATE: (hubspotId: string): string => {
        return `/accounts/mkt/${hubspotId}`;
    }
};
